import * as React from 'react'
import { useSearchParams } from 'react-router-dom';
import Filter from './VideoTab/Filter';
import Header from './VideoTab/Header';
import VideosList from './VideoTab/VideosList';
import { useEffect } from 'react';
import { useHomePageContentStore } from 'src/hooks/HomePageContent';

const VideoTab = () => {
    const [{ }, { get_video_list }] = useHomePageContentStore();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        async function fetchHere() {
            await getVideoList()
        }
        fetchHere()
    }, []);

    const getVideoList = async () => {
        let search_keyword = searchParams.get('search')
        await get_video_list({
            "page": 1,
            "limit": 10,
            "sort": "",
            "searchParam": search_keyword
        })
    }

    return (
        <div id="contentTypeVideo" className="tab-pane fade active in">
            <div className='videos-content-wrapper'>
                <div className='bs5 row'>
                    <div className='col-lg-3 tab-sidebar'>
                        <Filter />
                        <div className='m-b-20' id="espotImg">
                        </div>
                        <div className='newsletter m-b-20'>
                            <div className='newsletter-title font-24 font-bold font-apercu'>Newsletter</div>
                            <p className='m-b-15 text-black'>Subscribe for online delivery</p>
                            <a className='bs5 btn btn-primary w135'>Sign up now</a>
                        </div>
                    </div>
                    <div className='col-lg-9 tab-data'>
                        <div className='all-content'>
                            <Header />
                            <hr />
                            <VideosList />

                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default VideoTab